import MainLayout from "../components/shared/MainLayout";
import Price from "../components/housePrice/Price";
import Hero from "../components/hero/Hero";

const HousePrice = () => {
  return (
    <MainLayout>
      <Hero title="House Price" link="housePrice" />
      <Price />
    </MainLayout>
  );
};

export default HousePrice;
